import { Button } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';

interface IProps {
	noteGroupId: string;
	disabled: boolean;
}

export const AddCorrectionNote = (props: IProps) => {
	const history = useHistory();

	return (
		<Button
			size="large"
			shape="round"
			type="primary"
			disabled={props.disabled}
			onClick={() => {
				history.push(`/correctionNote/create/${props.noteGroupId}`);
			}}
		>
			Create correction note
		</Button>
	);
};
